/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc.
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import React from "react";
import { Provider } from "react-redux";
import App from "./App";
import store from "./store";
import * as serviceWorker from "./serviceWorker";
import ReactDOM from "react-dom/client";
import "./styles/global.scss";
import { asyncWithLDProvider } from "launchdarkly-react-client-sdk";

import { ConfigurationVariables } from "./config";

(async () => {
  const FeatureTogglesProvider = await asyncWithLDProvider({
    clientSideID: ConfigurationVariables.LAUNCHDARKLYCLIENTID,
  });

  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
  );
  root.render(
    <React.StrictMode>
      <FeatureTogglesProvider>
        <Provider store={store}>
          <App />
        </Provider>
      </FeatureTogglesProvider>
    </React.StrictMode>
  );
})();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
